import axios from "axios";
import { REMOTE_API_BASE_URL } from "@/constants/api";

export const remoteAPI = axios.create({
  baseURL: REMOTE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default remoteAPI;
